import React, { useState } from "react";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Flex, Space, Row, Button, Dropdown, Switch, Badge } from "antd";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import TableAntd from "components/elements/Table";
import dayjs from "dayjs";
import AdminRoleFilter from "./AdminRoleFilter";
import AdminRoleModal from "./AdminRoleModal";

const AdminRole = ({
  adminRoleList = [],
  pagination = {},
  isOpenModal = false,
  onStatus = () => { },
  onEdit = () => { },
  onClose = () => { },
  isEdit = false,
  selectedRecord = null,
  onSubmit = () => { },
  onCreate = () => { },
  onDelete = () => { },
  handleSearch = () => { }
}) => {
  const { t, i18n } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);

  const columns = [
    {
      title: <div className="text-table">{t("common.index")}</div>,
      dataIndex: "index",
      key: "index",
      align: "center",
      width: 100,
      render: (_, record, idx) => {
        return <Badge count={(pagination.current - 1) * pagination.size + idx + 1} style={{ backgroundColor: "#F5F6F7", color: "#313131" }} />
      },
    },
    {
      title: <div className="text-table">{t("translation.role.entity")}</div>,
      dataIndex: "roleName",
      key: "roleName",
      render: (_, record) => {
        return (
          <span>
            {i18n.language == "en" ? record?.roleNameEn : record?.roleName}
          </span>
        )
      }
    },
    {
      title: <div className="text-table">{t("admin_setting.label.Description")}</div>,
      dataIndex: "description",
      key: "description",
      render: (_, record) => {
        return (
          <span>{i18n.language == "en" ? record?.descriptionEn : record?.description}</span>
        )
      }
    },
    {
      title: <div className="text-table">{t("admin_setting.label.create_date")}</div>,
      dataIndex: "createDate",
      key: "createDate",
      width: 150,
      render: (_, record) => {
        return (
          <span>{i18n.language == "en" ? dayjs(record?.createDate).format("DD/MM/YYYY") : dayjs(record?.createDate).format("DD/MM/BBBB")}</span>
        )
      }
    },
    {
      title: <div style={{ color: "#667085" }} className="text-table">{t("master_data.label.status")}</div>,
      dataIndex: "statusFlag",
      key: "statusFlag",
      width: 120,
      render: (text, record) => (
        <Switch
          checked={text === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record)}
        />
      ),
    },
    {
      title: "",
      key: "action",
      align: "center",
      width: 80,
      render: (text, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "1",
                onClick: () => onEdit(record),
                label: t("action.edit"),
                icon: <EditOutlined style={{ fontSize: "18px", color: "gray" }}
                />,
              },
              (record?.editableFlag !== "N" || null) &&
              {
                key: "2",
                onClick: () => onDelete(record),
                label: t("action.delete"),
                icon: <DeleteOutlined style={{ fontSize: "18px", color: "gray" }}
                />
              }
            ],
          }}
        >
          <MoreOutlined style={{ fontSize: "20px", color: "gray", cursor: "pointer" }} />
        </Dropdown>
      ),
    },
  ];

  return (
    <>
      <AdminRoleModal
        isOpenModal={isOpenModal}
        onClose={onClose}
        isEdit={isEdit}
        selectedRecord={selectedRecord}
        onSubmit={onSubmit}
      />
      <Space style={{ width: "100%" }} size={24} direction="vertical">
        <Row justify="end" style={{ gap: "10px" }}>
          <Button
            type="default"
            onClick={() => setUseFilter(!useFilter)}
            style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}
          >
            <Flex align="center" justify="center" gap={8}>
              <FilterIcon />
              <span style={{ color: "#667085" }}>{t("common.filter")}</span>
            </Flex>
          </Button>

          <Button
            style={{
              width: "max-content",
              height: "44px",
              borderRadius: "8px",
              backgroundColor: "var(--button-color)",
              padding: "10px 16px",
            }}
            type="primary"
            onClick={() => { onCreate() }}
          >
            <Flex align="center" justify="center" gap={8}>
              <CreateIcon />
              {t("setting_project.label.add_role")}
            </Flex>
          </Button>
        </Row>

        {useFilter && (
          <AdminRoleFilter
            handleSearch={handleSearch}
          />
        )}

        <TableAntd
          columns={columns}
          dataSource={adminRoleList}
          pagination={{
            ...pagination
          }}
        />
      </Space>
    </>
  );
};

export default AdminRole;
